import React from 'react';
import type { FC } from 'react';
import ActionSheet from 'components/Common/ActionSheet';
import MuiButton from 'components/Common/MuiButton';
import i18n from 'locales/fa.json';
import { StyledDiv } from 'theme/commonStyled';
import Icon from 'components/Common/Icon';
import useProfileStore from 'store/profile';
import useExpireActionSheet from './useExpireActionSheet';
import { generateExpirationText } from 'utils/permission.util';

const ExpireActionSheet: FC = () => {
  const expirePackages =
    useProfileStore((state) => state.purchasedPackageData?.expirePackages) ||
    {};
  const {
    openActionSheetStatus,
    setOpenActionSheetStatus,
    handleCloseActionSheet,
  } = useExpireActionSheet();

  return (
    <ActionSheet
      footer={false}
      open={openActionSheetStatus}
      onDismiss={(): void => setOpenActionSheetStatus(false)}
      data-cy="expire-action-sheet"
      id="expire-action-sheet"
    >
      <StyledDiv textAlign="center">
        <Icon
          name="warning"
          fontSize={21}
          color={expirePackages.type === 'expired' ? 'rose80' : 'sun80'}
        />
        <StyledDiv my={5} fontSize={4} color="ash100" fontWeight="600">
          {expirePackages.type === 'expired'
            ? i18n.expiredModal.expiredPackage
            : i18n.expiredModal.extendPackage}
        </StyledDiv>
        <StyledDiv
          fontSize={4}
          px={8}
          textAlign="center"
          color="ash80"
          fontWeight="400"
          lineHeight="2"
        >
          <div>{generateExpirationText(expirePackages, true)}</div>
          <div>
            {expirePackages.type === 'expired'
              ? i18n.expiredModal.expiredPackageText2
              : i18n.expiredModal.extendPackageText2}
          </div>
        </StyledDiv>
        <StyledDiv isCenter mt={10} gap={10}>
          <MuiButton
            variant="white"
            flex={1}
            onClick={(): void => handleCloseActionSheet()}
          >
            {i18n.addToHomeScreen.buttonText}
          </MuiButton>
          <MuiButton
            flex={1}
            type="submit"
            onClick={(): void => {
              handleCloseActionSheet(true);
            }}
          >
            {expirePackages.type === 'expired'
              ? i18n.expiredModal.purchasePackage
              : i18n.expiredModal.extendPackage}
          </MuiButton>
        </StyledDiv>
      </StyledDiv>
    </ActionSheet>
  );
};

export default ExpireActionSheet;
